module.exports = __webpack_public_path__ + "e73ba077f2ed04b7323b20103a06f34b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/new_york_times_2023_chart.png
// module id = 1703
// module chunks = 0